// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","messageCopy":"G8c5892","twrCopy":"G9d0dfa","noShadow":"G0bbc50","buttonRow":"Ge01386","spinner":"G64d5a1"};